'use client';

import { Slider } from '@/widgets/Slider';

import { StoreCard } from '../StoreCard';
import { StoresSeeAllCard } from '../StoresSeeAllCard';
import { NearestStoresListProps } from './models';

export const NearestStoresList = ({ stores, showDistance, activeStoreId, onShowOnMap, seeAll }: NearestStoresListProps) => {
    const slides = [
        ...stores.map((store) => (
            <StoreCard key={store.uuid} store={store} showDistance={showDistance} isActive={activeStoreId === store.uuid} onShowOnMap={onShowOnMap} />
        )),
        <StoresSeeAllCard key='see-all' href={seeAll.href} total={seeAll.total} cityName={seeAll.cityName} />
    ];

    return (
        <div role='region' aria-roledescription='carousel' aria-label='فروشگاه‌ها'>
            <Slider
                dir='rtl'
                spaceBetween={16}
                slidesPerView={1.12}
                navigation
                watchOverflow
                grabCursor
                swiperSlideClassName='!h-auto'
                breakpoints={{ 640: { slidesPerView: 2.1 }, 1024: { slidesPerView: 3 } }}
                className='!relative !px-1 !py-2 max-md:[&_.custom-swiper-button-next]:hidden max-md:[&_.custom-swiper-button-prev]:hidden'>
                {slides}
            </Slider>
        </div>
    );
};
